import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithTokenRefresh } from '../../common/baseQuery'

import { BasePageRequest, BasePageResponse, BaseRequest, BaseResponse } from '../models'

import { paginate } from '../utils'
import { BusinessEvent } from '../../models/BusinessEvent'

const _BASE_URL = import.meta.env.REACT_APP_AI_BASE_URL!

interface BaseGetBusinessEventsRequest {
  sourceType?: string
  sourceKey?: string
  partialKeyMatch?: boolean
  clientId?: string
}

export interface GetBusinessEventsRequest extends BasePageRequest, BaseGetBusinessEventsRequest {}

export interface GetAllBusinessEventsRequest extends BaseRequest, BaseGetBusinessEventsRequest {}

export const businessEventApi = createApi({
  reducerPath: 'businessEventApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  tagTypes: ['BusinessEvent'],
  endpoints: (builder) => ({
    getBusinessEvents: builder.query<BasePageResponse<BusinessEvent[]>, GetBusinessEventsRequest>({
      query: (request) => {
        const { pageRequest, sourceType, sourceKey, partialKeyMatch, clientId } = request
        return {
          url: `/accounts/${request.accountId}/business-events`,
          params: {
            page: pageRequest.page,
            size: pageRequest.size,
            ...(sourceType ? { sourceType } : {}),
            ...(sourceKey ? { sourceKey } : {}),
            ...(partialKeyMatch ? { partialKeyMatch } : {}),
            ...(clientId ? { clientId } : {}),
          },
        }
      },
      providesTags: ['BusinessEvent'],
    }),
    getAllBusinessEvents: builder.query<BaseResponse<BusinessEvent[]>, GetAllBusinessEventsRequest>({
      async queryFn(request, _queryApi, _extraOptions, fetchWithBQ) {
        const { sourceType, sourceKey, partialKeyMatch, clientId } = request
        return await paginate<BusinessEvent>(
          {
            url: `/accounts/${request.accountId}/business-events`,
            params: {
              ...(sourceType ? { sourceType } : {}),
              ...(sourceKey ? { sourceKey } : {}),
              ...(partialKeyMatch ? { partialKeyMatch } : {}),
              ...(clientId ? { clientId } : {}),
            },
          },
          fetchWithBQ,
        )
      },
      providesTags: ['BusinessEvent'],
    }),
  }),
})

export const { useLazyGetAllBusinessEventsQuery } = businessEventApi
